import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Link } from 'react-router-dom'
import { Switch } from 'components'
import styles from './index.module.css'

const CertiMenu = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding">
				<div className={styles.title}>인증/보안</div>
				<ul className={`${styles["link-menu"]} mt_40`}>
					<li>
						<Link to="">
							<p>간편비밀번호 변경</p>
							<i className="icon icon_arrow_sm right" />
						</Link>
					</li>
					<li>
						<div className="flex-justify_between align_center">
							<p>생체인증 서비스 이용</p>
							<Switch offText="OFF">ON</Switch>
						</div>
					</li>
					<li>
						<Link to="/setting/certiManage">
							<p>인증서관리</p>
							<i className="icon icon_arrow_sm right" />
						</Link>
					</li>
				</ul>
			</div>
		</div>
	)
}

export default CertiMenu
